
function SwiperCard({ name, title, company, testimonial , user }) {
  return (
    <div className="w-11/12 md:w-10/12 p-3 bg-white/10 md:px-10 backdrop-blur-sm md:py-10 min-h-[650px] md:min-h-0 flex flex-wrap md:flex-nowrap justify-center items-center m-auto rounded-3xl">
      <div className="w-full md:w-[55%] text-center md:text-left">
        <h2 className="font-semibold font-poppins text-3xl text-white  tracking-wide">{company}</h2>
        <h3 className="bg-clip-text font-bold text-lg md:text-2xl mt-5 text-transparent bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
          {testimonial.title}
        </h3>
        <p className="mt-5 leading-7 text-sm tracking-wider text-white font-thin">
          {testimonial.content}
        </p>
        <h3 className="font-bold mt-5 text-white">{name}</h3>
        <h4 className="text-white ">
          Member of <span className="font-bold uppercase">{company}</span>
        </h4>
      </div>
      <div className="w-full items-center justify-center flex md:w-[40%]">
        <img
          src={user}
          className="rounded-[50%] md:ml-24 w-[200px] md:w-[350px] h-[200px] md:h-[350px] object-cover"
          alt={name}
        />
      </div>
    </div>
  );
}

export default SwiperCard;
